<app-page-title title="Cadastrar Plataforma" icon="fa-plug">
  <button
    type="button"
    class="sf-btn sf-btn--primary"
    (click)="openCreate()"
    data-testid="integration-template-new"
  >
    Nova Plataforma
  </button>
</app-page-title>

<div class="card">
  <!-- Esqueleto da lista (CU-86akkubzz): a tela saiu do overlay global. -->
  <app-skeleton *ngIf="loading" variant="table-row" [count]="5" [columns]="3"
    label="Carregando as plataformas" data-testid="integration-templates-loading"></app-skeleton>

  <div *ngIf="!loading && events.length === 0" class="alert alert-info">
    Nenhum evento cadastrado ainda.
  </div>

  <div class="list" *ngIf="!loading">
    <div
      *ngFor="let event of events; trackBy: trackById"
      class="row-item d-flex align-items-center mt-2 ps-2"
    >
      <div class="flex-grow-1 info">
        <div class="name">
          {{ event.name }}
          <span class="badge bg-info ms-2" *ngIf="isGlobal(event)">Evento oficial</span>
          <span class="badge bg-secondary ms-2" *ngIf="isOwn(event) && !isAdmin">Minha Plataforma</span>
          <span
            *ngIf="!isGlobal(event)"
            class="badge ms-2"
            [ngClass]="statusClass(event.approval_status)"
            (click)="isRejected(event) ? openRejectionReason(event) : null"
            [style.cursor]="isRejected(event) ? 'pointer' : 'default'"
            [attr.data-testid]="'integration-template-status-' + event.id"
          >
            {{ statusLabel(event.approval_status) }}
          </span>
        </div>
        <div class="description" *ngIf="event.description">{{ event.description }}</div>
        <div
          *ngIf="isOwn(event) && isPending(event)"
          class="alert alert-warning mt-2 mb-1 py-1 px-2"
          [attr.data-testid]="'integration-template-pending-banner-' + event.id"
        >
          <i class="fa fa-clock-o me-1"></i>
          Aguardando aprovação da equipe SMSFunnel
        </div>
        <div
          *ngIf="isOwn(event) && isRejected(event)"
          class="alert alert-danger mt-2 mb-1 py-1 px-2"
          [attr.data-testid]="'integration-template-rejected-banner-' + event.id"
        >
          <i class="fa fa-times-circle me-1"></i>
          Evento rejeitado.
          <button
            type="button"
            class="sf-btn sf-btn--ghost sf-btn--sm ms-1"
            (click)="openRejectionReason(event)"
            [attr.data-testid]="'integration-template-rejected-see-reason-' + event.id"
          >
            Ver motivo
          </button>
        </div>
      </div>

      <button
        *ngIf="isAdmin && isPending(event)"
        type="button"
        class="sf-btn sf-btn--primary me-2"
        [appLoadingButton]="busyEventId === event.id"
        [disabled]="busyEventId !== null"
        (click)="approve(event)"
        [attr.data-testid]="'integration-template-approve-' + event.id"
      >
        <i class="fa fa-check"></i> Aprovar
      </button>

      <button
        *ngIf="isAdmin"
        type="button"
        class="sf-btn sf-btn--secondary sf-btn--icon me-2"
        aria-label="Duplicar"
        (click)="openClone(event)"
        [attr.data-testid]="'integration-template-clone-' + event.id"
      >
        <i class="fa fa-copy"></i>
      </button>

      <button
        *ngIf="canEdit(event)"
        type="button"
        class="sf-btn sf-btn--secondary sf-btn--icon me-2"
        aria-label="Editar"
        (click)="openEdit(event)"
        [attr.data-testid]="'integration-template-edit-' + event.id"
      >
        <i class="fa fa-edit"></i>
      </button>

      <button
        *ngIf="!canEdit(event)"
        type="button"
        class="sf-btn sf-btn--ghost sf-btn--icon me-2"
        aria-label="Visualizar"
        (click)="view(event)"
        [attr.data-testid]="'integration-template-view-' + event.id"
      >
        <i class="fa fa-eye"></i>
      </button>

      <button
        *ngIf="isAdmin"
        type="button"
        class="sf-btn sf-btn--danger sf-btn--icon"
        aria-label="Excluir"
        [appLoadingButton]="busyEventId === event.id"
        [disabled]="busyEventId !== null"
        (click)="delete(event)"
        [attr.data-testid]="'integration-template-delete-' + event.id"
      >
        <i class="fa fa-trash"></i>
      </button>
    </div>
  </div>

  <app-pagination
    *ngIf="!loading && totalItems > 0"
    [currentPage]="currentPage"
    [itemsPerPage]="perPage"
    [totalItems]="totalItems"
    (pageChanged)="pageChanged($event)"
  ></app-pagination>
</div>

<ng-template #modalEdit let-modal>
  <form [formGroup]="form" (ngSubmit)="save()">
    <div class="modal-header">
      <!-- F4: Title simplificado (2 passos) -->
      <h4 class="modal-title">{{ modalTitle }} ({{ currentStep }}/{{ maxStep }})</h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Fechar"
        (click)="modal.dismiss()"
      ><span aria-hidden="true">&times;</span></button>
    </div>

    <div class="modal-body">
      <!-- F4: Stepper 2 passos -->
      <div class="stepper">
        <span class="stepper-item" [class.active]="currentStep === 1">1. Identificação</span>
        <span class="stepper-item" [class.active]="currentStep === 2">2. Eventos</span>
      </div>

      <div *ngIf="currentStep === 1">
        <div class="form-group">
          <label for="integration-template-name">Nome</label>
          <input
            id="integration-template-name"
            type="text"
            class="form-control"
            formControlName="name"
            maxlength="120"
            data-testid="integration-template-name"
            (blur)="onNameChange(form.get('name')?.value || '')"
          />
          <div
            class="text-danger"
            *ngIf="form.controls['name'].invalid && form.controls['name'].touched"
          >
            O nome é obrigatório (até 120 caracteres).
          </div>
        </div>

        <!-- SMS-006: Banner de sugestão de template similar -->
        <div *ngIf="suggestions && suggestions.length > 0" class="alert alert-warning mt-3" data-testid="suggestion-banner">
          <p class="mb-2">
            <i class="fa fa-lightbulb-o me-2"></i>
            <strong>Detectamos que esse formato é similar a {{ suggestionNames }}</strong> (aprovado pela equipe). Quer usar em vez de criar um novo?
          </p>
          <div class="mt-2">
            <button
              type="button"
              class="sf-btn sf-btn--primary sf-btn--sm me-2"
              *ngFor="let suggestion of suggestions"
              (click)="useSuggestion(suggestion)"
              [attr.data-testid]="'use-suggestion-' + suggestion.id"
            >
              <i class="fa fa-check"></i> Usar {{ suggestion.name }}
            </button>
            <button
              type="button"
              class="sf-btn sf-btn--secondary sf-btn--sm"
              (click)="suggestions = []"
            >
              Continuar criando
            </button>
          </div>
        </div>

        <div class="form-group">
          <label for="integration-template-description">Descrição</label>
          <textarea
            id="integration-template-description"
            class="form-control"
            rows="3"
            formControlName="description"
            data-testid="integration-template-description"
          ></textarea>
        </div>

        <!-- SMS-013: Nichos / Segmentos (operation_types) -->
        <div class="form-group mt-3">
          <label for="integration-template-operation-types">Nichos / Segmentos</label>
          <tag-input
            id="integration-template-operation-types"
            formControlName="operation_types"
            [onlyFromAutocomplete]="true"
            [modelAsStrings]="true"
            placeholder="+ Nicho"
            secondaryPlaceholder="Digite para buscar nichos"
            data-testid="integration-template-operation-types"
          >
            <tag-input-dropdown
              [autocompleteItems]="operationTypes"
              [showDropdownIfEmpty]="true"
              [focusFirstElement]="true"
            ></tag-input-dropdown>
          </tag-input>
          <small class="text-muted">
            Segmente esta integração por nichos de operação. Digite para buscar e clique para adicionar.
          </small>
        </div>

      </div>

      <!-- SMS-013: Passo 2 — Eventos (com payload_example + match_condition + mapping) -->
      <div *ngIf="currentStep === 2" class="step-content" data-testid="step-events">
        <h3>Eventos da Plataforma</h3>
        <p class="hint">
          Defina os eventos que esta integração reconhece. Cada evento usa um payload de exemplo (JSON)
          para extrair caminhos, condições para filtrar quando se aplica, e mapeamento para preencher os leads.
        </p>

        <!-- Os eventos chegam do GET completo; até lá a lista seria "nenhum evento". -->
        <app-skeleton *ngIf="loadingDetail" variant="table-row" [count]="3" [columns]="2"
          label="Carregando os eventos da plataforma" data-testid="template-events-loading"></app-skeleton>

        <div *ngIf="!loadingDetail && templateEvents.length === 0" class="alert alert-info">
          Nenhum evento cadastrado. Clique em <strong>Adicionar evento</strong> para começar.
        </div>

        <div class="template-events-list" *ngIf="!loadingDetail && templateEvents.length > 0">
          <div
            *ngFor="let ev of templateEvents; let i = index; trackBy: trackTemplateEvent"
            class="row-item d-flex align-items-start mt-2 p-2 border rounded"
            [attr.data-testid]="'template-event-' + i"
          >
            <div class="flex-grow-1">
              <div class="d-flex align-items-center">
                <strong>{{ ev.name }}</strong>
              </div>
              <div class="small text-muted mt-1">
                <i class="fa fa-filter me-1"></i>{{ matchConditionSummary(ev) }}
              </div>
              <div class="small text-muted mt-1">
                <i class="fa fa-exchange me-1"></i>{{ mappingCount(ev) }} mapeamento(s)
              </div>
              <div *ngIf="ev.payload_example" class="small text-muted mt-1">
                <i class="fa fa-code me-1"></i>Payload exemplo definido
              </div>
            </div>

            <button
              type="button"
              class="sf-btn sf-btn--secondary sf-btn--sm sf-btn--icon me-2"
              (click)="openEventEditor(ev)"
              *ngIf="!viewOnly"
              [attr.data-testid]="'template-event-edit-' + i"
              aria-label="Editar evento"
            >
              <i class="fa fa-edit"></i>
            </button>
            <button
              type="button"
              class="sf-btn sf-btn--danger sf-btn--sm sf-btn--icon"
              (click)="removeTemplateEvent(i)"
              *ngIf="isAdmin && !viewOnly"
              [attr.data-testid]="'template-event-remove-' + i"
              aria-label="Remover evento"
            >
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>

        <button
          type="button"
          class="sf-btn sf-btn--secondary mt-3"
          (click)="openEventEditor()"
          *ngIf="!viewOnly"
          [disabled]="loadingDetail"
          data-testid="add-template-event"
        >
          <i class="fa fa-plus"></i> Adicionar evento
        </button>
      </div>
    </div>

    <div class="modal-footer">
      <button
        type="button"
        class="sf-btn sf-btn--ghost"
        (click)="modal.dismiss()"
      >
        Cancelar
      </button>
      <button
        type="button"
        class="sf-btn sf-btn--secondary"
        *ngIf="currentStep > 1"
        (click)="prevStep()"
        data-testid="integration-template-prev"
      >
        Voltar
      </button>
      <!-- F4: Botão Próximo até maxStep=2 -->
      <button
        type="button"
        class="sf-btn sf-btn--primary"
        *ngIf="currentStep < maxStep"
        (click)="nextStep()"
        data-testid="integration-template-next"
      >
        Próximo
      </button>
      <!-- F4: Botão Salvar apenas no último passo -->
      <button
        *ngIf="currentStep === maxStep && !viewOnly"
        type="submit"
        class="sf-btn sf-btn--primary"
        [appLoadingButton]="saving"
        [disabled]="loadingDetail"
        data-testid="integration-template-save"
      >
        Salvar
      </button>
    </div>
  </form>
</ng-template>

<ng-template #modalSentForReview let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Evento enviado para análise</h4>
  </div>
  <div class="modal-body">
    <p class="mb-0" data-testid="integration-template-sent-for-review-message">
      Sua integração será analisada pela equipe da SMSFunnel para garantir o sucesso.
    </p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="sf-btn sf-btn--primary"
      (click)="closeSentForReviewModal()"
      data-testid="integration-template-sent-for-review-ack"
    >
      Entendi
    </button>
  </div>
</ng-template>

<ng-template #modalRejectionReason let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Motivo da rejeição — {{ rejectionReasonEventName }}</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Fechar"
      (click)="modal.dismiss()"
    ><span aria-hidden="true">&times;</span></button>
  </div>
  <div class="modal-body">
    <p data-testid="integration-template-rejection-text">{{ rejectionReasonView }}</p>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="sf-btn sf-btn--ghost"
      (click)="modal.dismiss()"
    >
      Fechar
    </button>
  </div>
</ng-template>

<ng-template #modalClone let-modal>
  <form [formGroup]="cloneForm" (ngSubmit)="doClone()">
    <div class="modal-header">
      <h4 class="modal-title">Duplicar plataforma</h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Fechar"
        (click)="modal.dismiss()"
      ><span aria-hidden="true">&times;</span></button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label for="integration-template-clone-name">Novo nome</label>
        <input
          id="integration-template-clone-name"
          type="text"
          class="form-control"
          formControlName="new_name"
          maxlength="120"
          data-testid="integration-template-clone-name"
        />
        <div
          class="text-danger"
          *ngIf="cloneForm.controls['new_name'].invalid && cloneForm.controls['new_name'].touched"
        >
          O novo nome é obrigatório (até 120 caracteres).
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="sf-btn sf-btn--ghost"
        (click)="modal.dismiss()"
      >
        Cancelar
      </button>
      <button
        type="submit"
        class="sf-btn sf-btn--primary"
        [appLoadingButton]="cloning"
        [disabled]="cloneForm.invalid"
        data-testid="integration-template-clone-save"
      >
        Duplicar
      </button>
    </div>
  </form>
</ng-template>
